var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notFound"},[_c('div',{staticClass:"innerContent"},[_c('h1',[_vm._v("404")]),_c('p',[_vm._v("Oops! Not Found")])])])
}]

export { render, staticRenderFns }